module.exports = DllOfReactDnd;